import React from "react";

function CountSection() {
    const countValue = {
        subscriber: 1312,
        registerTruck: 100,
        availableTruck: 6,
        postLoads: 4,
        transporter: 40000,
        packersandmovers: 1000
    };

    return (
        <section id="counts" className="counts section-bg">
            <div className="container">
                <div className="row justify-content-center text-center">  {/* Center the items */}
                    <div className="col-lg-2 col-md-5 col-6 d-flex flex-column align-items-center">
                        <div className="count-box">
                        <img src='https://moverstrip-dev.s3.us-east-1.amazonaws.com/system/homeIcon/trasnporter.png' style={{ width: "40%", marginTop: 30, margin: '0 auto' }} class="card-img-top" />

                            <span>{countValue.transporter}</span>
                            <p>Transporter Directory</p>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-5 col-6 d-flex flex-column align-items-center">
                        <div className="count-box">
                        <img src='https://moverstrip-dev.s3.us-east-1.amazonaws.com/system/homeIcon/cargo-mover.png' style={{ width: "40%", marginTop: 30, margin: '0 auto' }} class="card-img-top" />

                            <span>{countValue.packersandmovers}</span>
                            <p>Packers And Movers</p>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-5 col-6 d-flex flex-column align-items-center">
                        <div className="count-box">
                        <img src='https://moverstrip-dev.s3.us-east-1.amazonaws.com/system/homeIcon/add-user.png' style={{ width: "40%", marginTop: 30, margin: '0 auto' }} class="card-img-top" />
                            <span>{countValue.subscriber}</span>
                            <p>Subscriber</p>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-5 col-6 d-flex flex-column align-items-center">
                        <div className="count-box">
                        <img src='https://moverstrip-dev.s3.us-east-1.amazonaws.com/system/homeIcon/gps.png' style={{ width: "40%", marginTop: 30, margin: '0 auto' }} class="card-img-top" />
                            <span>{countValue.registerTruck}</span>
                            <p>Registered GPS Truck</p>
                        </div>
                    </div>

                    {/* <div class="col-lg-2 col-md-5 col-6 d-md-flex align-items-md-stretch">
                        <div class="count-box">
                            <img src='https://moverstrip-dev.s3.us-east-1.amazonaws.com/system/homeIcon/available-load.png' style={{ width: "40%", marginTop: 30, margin: '0 auto' }} class="card-img-top" />
                       
                                <span data-toggle="counter-up">{countValue.postLoads}</span>
                                <p>Post Loads</p>
                            </div>
                        </div> */}


                        {/* <div class="col-lg-2 col-md-5 col-6 d-md-flex align-items-md-stretch">
                        <div class="count-box">
                            <img src='https://moverstrip-dev.s3.us-east-1.amazonaws.com/system/homeIcon/available-truck.png' style={{ width: "40%", marginTop: 30, margin: '0 auto' }} class="card-img-top" />
                       
                                <span data-toggle="counter-up">{countValue.availableTruck}</span>
                                <p>Available Truck</p>
                            </div>
                        </div> */}

                </div>
            </div>
        </section>
    );
}

export default CountSection;
